<template>
  <div class="footer">
    <div class="pc-container">
      <img class="footer-img" src="../../assets/images/pc/common/footer.jpg" >
      <div class="footer-link">
        <img class="button" src="../../assets/images/pc/common/footer_5.png" />
        <img class="line" src="../../assets/images/pc/common/line.png" />
        <img @click="onLinkClick(3)" class="button" src="../../assets/images/pc/common/footer_4.png" />
        <img class="line" src="../../assets/images/pc/common/line.png" />
        <img @click="onLinkClick(2)" class="button" src="../../assets/images/pc/common/footer_3.png" />
        <img class="line" src="../../assets/images/pc/common/line.png" />
        <img @click="onLinkClick(1)" class="button" src="../../assets/images/pc/common/footer_2.png" />
        <img class="line" src="../../assets/images/pc/common/line.png" />
        <img @click="onLinkClick(0)" class="button" src="../../assets/images/pc/common/footer_1.png" />
      </div>
      <!-- <div class="button footer-pingan_official button">
        <a href="https://property.pingan.com/">        
          <img class="" src="../../assets/images/pc/common/pingan_official.png" >
        </a>
      </div>
      <div class="button footer-pingan_school_official button">
        <a href="https://campus.pingan.com/pacx">
          <img src="../../assets/images/pc/common/pingan_school_official.png" >
        </a>
      </div> -->
    </div>
    <div class="mobile-container">
      <img class="footer-img" src="../../assets/images/mobile/common/footer.jpg" />
      <div class="footer-link">
        <div class="footer-link1 footer-link__info">
          <img class="button" src="../../assets/images/pc/common/footer_5.png" />
          <img class="line" src="../../assets/images/pc/common/line.png" />
          <img @click="onLinkClick(3)" class="button" src="../../assets/images/pc/common/footer_4.png" />
          <img class="line" src="../../assets/images/pc/common/line.png" />
          <img @click="onLinkClick(2)" class="button" src="../../assets/images/pc/common/footer_3.png" />
        </div>
        <div class="footer-link2 footer-link__info">
          <img @click="onLinkClick(1)" class="button" src="../../assets/images/pc/common/footer_2.png" />
          <img class="line" src="../../assets/images/pc/common/line.png" />
          <img @click="onLinkClick(0)" class="button" src="../../assets/images/pc/common/footer_1.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onLinkClick (index) {
      const links = [
        'https://campus.pingan.com/pacx',
        'https://property.pingan.com/',
        'http://www.isc-org.cn/',
        'http://www.sinoins.com/ ',
      ]
      window.open(links[index])
    }
  }
}
</script>
<style scoped>
.footer{
  width: 100%;
}
.footer-img{
  width: 100%;
}
.footer .button{
  top: 48%;
}
.footer .footer-pingan_official{
  width: 14.9vw;
  left: 25.39vw;
  position: absolute;
}
.footer .footer-pingan_school_official{
  width: 14.9vw;
  left: 32.29vw;
  position: absolute;
}
.footer a{
  opacity: 1;
}
.footer-link01{
  width: 41%;
  position: absolute;
  left: 119px;
  bottom: 52px;
}
.footer-link02{
  width: 42%;
  position: absolute;
  left: 191px;
  bottom: 51px;
  z-index: 12;
}
.footer .pc-container .button{
  height: 4.8%;
  width: auto;
  position: relative;
  top: 66%;
}
.footer .pc-container .line{
  height: 4.8%;
  width: auto;
  margin: 0 0.4%;
  top: 66%;
}
.footer .footer-link{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  left: 0px;
  top: 0px;
  justify-content: center;
}
.footer .mobile-container .footer-link{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footer .mobile-container .button{
  height: 8px;
  width: auto;
  top: 68%;
  position: relative;
  margin: 5px;
}
.footer .mobile-container .line{
  height: 8px;
  width: auto;
  top: 68%;
  position: relative;
  margin: 5px;
}
.footer-link__info{
  display: flex;
  align-items: center;
}
.footer-link2{
  top: 14%;
}
.footer-link1{
  top: 15%;
  z-index: 100;
}
</style>